// extracted by mini-css-extract-plugin
export default {"deleteIcon":"TaskTableRow_deleteIcon__+Yu4-"};